import { Layers, Palette } from 'lucide-react'

interface FunnelTabsProps {
  activeTab: 'logic' | 'uxui'
  onChange: (tab: 'logic' | 'uxui') => void
}

export function FunnelTabs({ activeTab, onChange }: FunnelTabsProps) {
  return (
    <div
      className="flex gap-1 px-6 pt-4 border-b"
      style={{
        borderColor: 'var(--fn-border)',
        backgroundColor: 'var(--fn-bg-card)',
      }}
    >
      <button
        type="button"
        className="flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-t-lg transition-colors"
        style={{
          color: activeTab === 'logic' ? 'var(--fn-primary)' : 'var(--fn-text-secondary)',
          backgroundColor: activeTab === 'logic' ? 'var(--fn-bg-hover)' : 'transparent',
          borderBottom: activeTab === 'logic' ? '2px solid var(--fn-primary)' : '2px solid transparent',
        }}
        onClick={() => onChange('logic')}
        aria-selected={activeTab === 'logic'}
      >
        <Layers className="w-4 h-4" />
        Funnel Logic
      </button>

      <button
        type="button"
        className="flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-t-lg transition-colors"
        style={{
          color: activeTab === 'uxui' ? 'var(--fn-primary)' : 'var(--fn-text-secondary)',
          backgroundColor: activeTab === 'uxui' ? 'var(--fn-bg-hover)' : 'transparent',
          borderBottom: activeTab === 'uxui' ? '2px solid var(--fn-primary)' : '2px solid transparent',
        }}
        onClick={() => onChange('uxui')}
        aria-selected={activeTab === 'uxui'}
      >
        <Palette className="w-4 h-4" />
        UX/UI Editor
      </button>
    </div>
  )
}
